import { Box, Button, Tooltip } from '@mantine/core';
import { showNotification } from '@shared/utils';
import { useConfirmCompanyNcc } from '../../companyApi';

type CompanyNccConfirmButtonProps = {
  companyId: string;
  isConfirmed: boolean;
  isNccChanged: boolean;
  onConfirm: (nccVerified: boolean) => void;
};

export const CompanyNccConfirmButton = ({
  companyId,
  isConfirmed,
  isNccChanged,
  onConfirm,
}: CompanyNccConfirmButtonProps) => {
  const { mutate: confirmNcc, isPending } = useConfirmCompanyNcc();

  const handleConfirm = () => {
    confirmNcc(companyId, {
      onSuccess: ({ nccVerified }) => {
        onConfirm(nccVerified);
        showNotification({ variant: 'success', message: 'NCC подтвержден' });
      },
      onError: error => {
        showNotification({
          error,
          variant: 'error',
          message:
            error.response?.data?.message || 'Не удалось подтвердить NCC',
        });
      },
    });
  };

  return (
    // The confirm endpoint confirms the saved NCC, so an edited value has
    // to be saved first. The wrapper keeps the tooltip on a disabled button.
    <Tooltip
      label='Сохраните изменения, чтобы подтвердить NCC'
      disabled={!isNccChanged}
      withArrow
    >
      <Box>
        <Button
          variant='outline'
          size='md'
          onClick={handleConfirm}
          loading={isPending}
          disabled={isConfirmed || isNccChanged || isPending}
          fullWidth
        >
          Подтвердить
        </Button>
      </Box>
    </Tooltip>
  );
};
